module.exports = __webpack_public_path__ + "img/support_a12.db040abf.png";